import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromAccount from './account.reducers';

export interface AccountState {
  stateData: fromAccount.State;
}

export interface State extends fromRoot.AppState {
  account: AccountState;
}

export const reducers = {
  stateData: fromAccount.reducer
};

export const selectAccountState = createFeatureSelector<AccountState>('account');

export const selectAccountStateData = createSelector(selectAccountState, (state: AccountState) => state.stateData);

export const getAccountState = createSelector(selectAccountStateData, fromAccount.getStateData);

export const getAccountScreenError = createSelector(selectAccountStateData, fromAccount.getError);

export const getAccountScreenPending = createSelector(selectAccountStateData, fromAccount.getPending);